import { TConsumerItem, TStoriesImages } from '../../types/data';

export enum TImageEnum {
    A = 'A',
    B = 'B',
}

const getBgImage2x = (images: TStoriesImages, image: TImageEnum): string | undefined => {
    switch (image) {
        case 'A':
            return images.bgImageA2x || images.bgImageA;
        case 'B':
            return images.bgImageB2x || images.bgImageB || getBgImage2x(images, TImageEnum.A);
    }
};
const getBgImage3x = (images: TStoriesImages, image: TImageEnum): string | undefined => {
    switch (image) {
        case 'A':
            return images.bgImageA3x || images.bgImageA2x || images.bgImageA;
        case 'B':
            return images.bgImageB3x || images.bgImageB2x || images.bgImageB || getBgImage3x(images, TImageEnum.A);
    }
};
export const getBgImage = (images: TStoriesImages, image: TImageEnum, x2 = false, x3 = false) => {
    switch (image) {
        case 'A':
            return x2 ? getBgImage2x(images, image) : x3 ? getBgImage3x(images, image) : images.bgImageA;
        case 'B':
            return x2 ? getBgImage2x(images, image) : x3 ? getBgImage3x(images, image) : images.bgImageB || images.bgImageA;
    }
};

export const getBg = (props: TConsumerItem, bgImageUrl?: string) => {
    if (!props.fullwidthImage && props.background) {
        return `var(--gradient-${props.background})`;
    }
    if (props.fullwidthImage && bgImageUrl) {
        return `url(${bgImageUrl}) no-repeat center center, rgba(0, 0, 0, 0.48)`;
    }
    return 'var(--color-purple_100)';
};
